const CalendarClock = ({ width, height, className, fillColor }: CalendarClockProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 39 38'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_12623_1202)'>
      <path
        d='M33 23V11.25C33 9.45507 31.5449 8 29.75 8H10.25C8.45507 8 6 9.45507 6 11.25V30.75C6 32.5449 8.45507 34 10.25 34H22'
        stroke={fillColor}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
        style={{ fill: 'none' }}
      />
      <path d='M26 4.75V11.0833' stroke={fillColor} stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
      <path d='M13 4.75V11.0833' stroke={fillColor} stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
      <path
        d='M6.5 17.4167H32.5'
        stroke={fillColor}
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M18.25 19.75H15V22.9167H18.25V19.75Z'
        stroke={fillColor}
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
        style={{ fill: 'none' }}
      />
      <path
        d='M12.25 19.75H9V22.9167H12.25V19.75Z'
        stroke={fillColor}
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
        style={{ fill: 'none' }}
      />
      <path
        d='M12.25 25.75H9V28.9167H12.25V25.75Z'
        stroke={fillColor}
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
        style={{ fill: 'none' }}
      />
      <path
        d='M18.25 25.75H15V28.9167H18.25V25.75Z'
        stroke={fillColor}
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
        style={{ fill: 'none' }}
      />
      <path
        d='M27.5 36C31.6421 36 35 32.6421 35 28.5C35 24.3579 31.6421 21 27.5 21C23.3579 21 20 24.3579 20 28.5C20 32.6421 23.3579 36 27.5 36Z'
        stroke={fillColor}
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
        style={{ fill: 'none' }}
      />
      <path
        d='M27.5 25.375V28.5H30.625'
        stroke={fillColor}
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_12623_1202'>
        <rect width='39' height='38' fill={fillColor} />
      </clipPath>
    </defs>
  </svg>
);

export type CalendarClockProps = {
  fillColor: string;
  className?: string;
  width: string | number;
  height: string | number;
};

CalendarClock.defaultProps = {
  width: 39,
  height: 38,
  fillColor: '#2A3745',
};

export default CalendarClock;
